﻿import { useMantineTheme } from "@mantine/core";

export function Logo() {
    const theme = useMantineTheme();

    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 118.3 64.3"
            xmlSpace="preserve"
            style={{ filter: (theme.colorScheme === 'dark') ? 'drop-shadow(-2px 2px 3px rgba(255, 255, 255, 0.5))' : 'drop-shadow(-2px 2px 3px rgba(0, 0, 0, 0.5))' }}
        >
            <style>
                {`.st0{fill:#F19D20;} .st1{display:none;} .st2{display:inline;} .st3{opacity:0.3;}`}
            </style>
            <g id="Layer_1"></g>
            <g id="Layer_2"></g>
            <g id="Layer_3">
                <g>
                    <g>
                        <g>
                            <polygon className="st0" points="69.9,59 81,29.2 72,5.6 60.7,34.7" />
                        </g>
                        <g>
                            <polygon className="st0" points="26,5.6 3.9,62.2 22.6,62.2 34.9,29.3" />
                        </g>
                        <g>
                            <polygon className="st0" points="59.2,38.4 45.5,2.1 27.4,2.1 50.2,62.2 68.3,62.2 68.3,62.2 59.3,38.4" />
                        </g>
                        <g>
                            <polygon className="st0" points="91.5,2.1 73.5,2.1 96.3,62.2 114.3,62.2" />
                        </g>
                    </g>
                </g>
            </g>
            <g id="Layer_4" className="st1"></g>
        </svg>
    );
}